import { CircularProgress, ListItemText, MenuItem, Paper, Popper, TextField, Typography, withStyles } from "@material-ui/core";
import * as AppActions from "app/store/actions";
import withReducer from "app/store/withReducer";
import match from "autosuggest-highlight/match";
import parse from "autosuggest-highlight/parse";
import clsx from "clsx";
import _ from "lodash";
import deburr from "lodash/deburr";
import React, { Component } from "react";
import Autosuggest from "react-autosuggest";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import * as Actions from "./Store/Actions/SuggestionFieldActions";
import reducer from "./Store/Reducers/SuggestionFieldReducer";

function renderInputComponent(inputProps) {
    // eslint-disable-next-line no-unused-vars
    const { variant, label, classes, inputRef = () => { }, ref, ...other } = inputProps;

    return (
        <div className="w-full relative">
            <React.Fragment>
                <TextField
                    label={label}
                    fullWidth
                    InputProps={{
                        inputRef: node => {
                            ref(node);
                            inputRef(node);
                        },
                        InputLabelProps: {
                            shrink: true
                        },
                        classes: {
                            input: clsx(classes.input, "py-0 px-16 h-48 pr-48"),
                            notchedOutline: "rounded-4"
                        }
                    }}
                    variant="outlined"
                    {...other}
                />
            </React.Fragment>
        </div>
    );
}

function renderSuggestion(suggestion, { query, isHighlighted }) {
    const matches = match(suggestion.nome, query);
    const parts = parse(suggestion.nome, matches);

    return (
        <MenuItem selected={isHighlighted} component="div">
            <ListItemText
                className="pl-0"
                primary={
                    parts.map((part, index) => {
                        return part.highlight ? (
                            <span key={String(index)} style={{ fontWeight: 600 }}>
                                {part.text}
                            </span>
                        ) : (
                            <strong key={String(index)} style={{ fontWeight: 300 }}>
                                {part.text}
                            </strong>
                        );
                    })
                }
            />
        </MenuItem>
    );
}

function getSuggestions(value, data) {
    const inputValue = deburr(value.trim()).toLowerCase();
    const inputLength = inputValue.length;
    let count = 0;

    return inputLength === 0
        ? []
        : data.filter(suggestion => {
            const keep =
                count < 10 &&
                match(suggestion.nome, inputValue).length > 0;

            if (keep) {
                count += 1;
            }

            return keep;
        });
}

function getSuggestionValue(suggestion) {
    return suggestion.nome;
}

const styles = theme => ({
    root: {},
    container: {
        position: "relative"
    },
    suggestionsContainerOpen: {
        position: "absolute",
        zIndex: 1,
        marginTop: theme.spacing.unit,
        left: 0,
        right: 0
    },
    suggestion: {
        display: "block"
    },
    suggestionsList: {
        margin: 0,
        padding: 0,
        listStyleType: "none"
    },
    input: {
        minHeight: 56,
        transition: theme.transitions.create(["background-color"], {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.short
        }),
        "&:focus": {
            backgroundColor: theme.palette.background.paper
        }
    }
});

class SuggestionField extends Component {

    state = {
        open: false,
        loading: false,
        texto: "",
        suggestions: [],
        noSuggestions: false,
        timer: null,
        bypassValidation: false,
    };

    componentDidMount() {
        const { value = "" } = this.props;
        this.setState({ texto: value, bypassValidation: value.length > 0 });
    }

    componentDidUpdate(prevProps, prevState) {
        const { list, xappRouteParams, campoFiltro, target, SuggestionField } = this.props;
        const form = this.state;

        if (SuggestionField.error) {
            this.props.showMessage({ message: SuggestionField.error, variant: "error" });
            SuggestionField.error = null;
            this.setState({ loading: false });
        }

        if (!form.bypassValidation && !form.loading && !_.isNull(form.texto) && !_.isEqual(form.texto, prevState.texto) && form.texto.length > 2) {
            clearTimeout(form.timer);
            let timer = setTimeout(() => {
                list(xappRouteParams, target, campoFiltro, _.trimEnd(_.toUpper(form.texto)), () => this.setState({ loading: false, "timer": null }));
            }, 1500);
            this.setState({ "loading": true, "timer": timer });
        }

        if (!_.isNull(SuggestionField.data) && !_.isEqual(SuggestionField.data, prevProps.SuggestionField.data)) {
            this.handleSuggestionsFetchRequested({ value: form.texto });
        }
    }

    showSuggestion = () => {
        this.setState({ open: true });
    };

    hideSuggestion = () => {
        const { value = "" } = this.props;
        this.setState({ open: false, texto: value });
    };

    handleSuggestionsFetchRequested = ({ value }) => {
        const { data } = this.props.SuggestionField;
        const suggestions = getSuggestions(value, !_.isNull(data) ? data : []);
        const isInputBlank = value.trim() === "";
        const noSuggestions = !isInputBlank && suggestions.length === 0;

        this.setState({ suggestions, noSuggestions });
    };

    handleSuggestionSelected = (event, { suggestion }) => {
        const { onSelected, campoID } = this.props;
        event.preventDefault();
        event.stopPropagation();

        onSelected(suggestion[campoID]);
        this.hideSuggestion();
    };

    handleSuggestionsClearRequested = () => {
        this.setState({
            suggestions: [],
            noSuggestions: false
        });
    };

    handleChangeTexto = (ev, { newValue }) => {
        this.setState({ texto: newValue, bypassValidation: false });
        this.props.onChange({ target: { name: this.props.name, value: newValue } });
    };

    handleClickAway = event => {
        return (
            !this.suggestionsNode ||
            !this.suggestionsNode.contains(event.target)
        ) && this.hideSuggestion();
    };

    handleRef = domNode => {
        this.textoNode = domNode;
    };

    handleSuggestionsRef = domNode => {
        this.suggestionsNode = domNode;
    };

    render() {
        const { classes, name, label = "", className } = this.props;
        const form = this.state;
        const autosuggestProps = {
            renderInputComponent,
            highlightFirstSuggestion: true,
            suggestions: form.suggestions,
            onSuggestionsFetchRequested: this.handleSuggestionsFetchRequested,
            onSuggestionsClearRequested: this.handleSuggestionsClearRequested,
            onSuggestionSelected: this.handleSuggestionSelected,
            getSuggestionValue,
            renderSuggestion
        };

        return (
            <div className={clsx("flex items-center w-full", className)} ref={this.handleRef}>
                <Autosuggest
                    {...autosuggestProps}
                    inputProps={{
                        variant: "basic",
                        classes,
                        name: name,
                        placeholder: label,
                        value: form.texto,
                        onChange: this.handleChangeTexto,
                        onFocus: this.showSuggestion,
                        InputLabelProps: {
                            shrink: true
                        },
                        autoFocus: false,
                    }}
                    theme={{
                        container: "flex flex-1 w-full",
                        suggestionsList: classes.suggestionsList,
                        suggestion: classes.suggestion
                    }}
                    renderSuggestionsContainer={options => (
                        <Popper
                            anchorEl={this.textoNode}
                            open={Boolean(options.children) || form.noSuggestions}
                            popperOptions={{ positionFixed: true }}
                            className="z-9999"
                        >
                            <div ref={this.handleSuggestionsRef}>
                                <Paper
                                    elevation={1}
                                    square
                                    {...options.containerProps}
                                    style={{ width: this.textoNode ? this.textoNode.clientWidth : null, maxHeight: 200, overflow: "auto" }}
                                >
                                    {options.children}
                                    {form.noSuggestions && (
                                        <Typography className="px-16 py-12">Sem resultados</Typography>
                                    )}
                                </Paper>
                            </div>
                        </Popper>
                    )}
                />
                {form.loading &&
                    <div className="flex h-56 w-32 justify-center items-center">
                        <CircularProgress size={"20px"} className="" />
                    </div>
                }
            </div>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        list: Actions.list,
        showMessage: AppActions.showMessage,
    }, dispatch);
}

function mapStateToProps({ SuggestionField }) {
    return {
        SuggestionField: SuggestionField,
    };
}

export default withReducer("SuggestionField", reducer)(withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(SuggestionField))));
